import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { PinAll } from '@marvelapp/ui';
// eslint-disable-next-line mobx/missing-observer
export default function BackgroundOverlay({ zIndex, }) {
    return _jsx(PinAll, { bg: "blackA6", zIndex: zIndex });
}
